const getThemeUnwrapped = (theme) => theme?.[GetThemeUnwrapped] || theme, GetThemeUnwrapped = Symbol();
export {
  GetThemeUnwrapped,
  getThemeUnwrapped
};
//# sourceMappingURL=getThemeUnwrapped.js.map
